<script setup lang="ts">
import { useId } from 'vue';
import Checkbox from '@/components/ui/checkbox/Checkbox.vue';
import Label from '@/components/ui/label/Label.vue';
import { cn } from '@/lib/utils';

const props = withDefaults(
    defineProps<{
        label: string;
        disabled?: boolean;
    }>(),
    { disabled: false },
);

const checked = defineModel<boolean>({ required: true });
const id = useId();
</script>

<template>
    <div
        :class="
            cn(
                'flex items-start gap-3 rounded-xl border border-gray-200/90 bg-gray-50/50 px-3 py-2.5 transition-colors',
                'dark:border-border/90 dark:bg-muted/50',
                'hover:border-brand-200/80 hover:bg-brand-50/30 dark:hover:border-brand-800/60 dark:hover:bg-brand-950/25',
                props.disabled && 'pointer-events-none opacity-50',
            )
        "
    >
        <Checkbox
            :id="id"
            v-model="checked"
            :disabled="props.disabled"
            class="mt-0.5"
        />
        <Label
            :for="id"
            :class="
                cn(
                    'cursor-pointer text-sm leading-snug font-normal text-muted-foreground',
                    'peer-data-[state=checked]:text-gray-900 dark:peer-data-[state=checked]:text-gray-100',
                )
            "
        >
            {{ label }}
        </Label>
    </div>
</template>
